import { Col, message, Row, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import { useState } from 'react';
import useDiagnostics from './hooks/useDiagnostics';

const DiagnosticSelector = ({
  form,
  diagnosticField,
  placeholder = 'Buscar diagnóstico...',
  showDiagnosticTypification,
  diagnosticTypificationOptions,
}) => {
  const [selected, setSelected] = useState();
  const diagnostic = useDiagnostics({
    defaultDiagnosticCodes: [],
  });

  const fetchDiagnostics = debounce(async (query) => {
    try {
      await diagnostic.fetchDiagnostics({ query: query, limit: 50 });
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al cargar diagnósticos',
        style: {
          marginTop: '35vh',
        },
      });
    }
  }, 500);

  const handleOnChange = (value, option) => {
    const { diagnostic: selectedDiagnostic } = option;
    selectedDiagnostic.diagnostic_id = selectedDiagnostic.id;
    selectedDiagnostic.indication = selectedDiagnostic.recommendations;
    selectedDiagnostic.suggestion = selectedDiagnostic.restrictions;

    let currentDiagnostics;

    if (Array.isArray(diagnosticField)) {
      const [containerFieldKey, index, childField] = diagnosticField;
      const diagnosticContainerList = form.getFieldValue(containerFieldKey) || [];
      currentDiagnostics = diagnosticContainerList[index]?.[childField] || [];
      const examId = diagnosticContainerList[index]?.examId;
      if (examId) {
        selectedDiagnostic.diagnosticable_type = 'AdmissionPatientExam';
        selectedDiagnostic.diagnosticable_id = examId;
      }
    } else {
      currentDiagnostics = form.getFieldValue(diagnosticField) || [];
    }

    setSelected(null);

    if (showDiagnosticTypification) {
      selectedDiagnostic.pathological = diagnosticTypificationOptions?.pathological?.defaultValue;
      selectedDiagnostic.classification = diagnosticTypificationOptions?.classification?.defaultValue;
      selectedDiagnostic.occupational = diagnosticTypificationOptions?.occupational?.defaultValue;
    }

    const updatedDiagnostics = [...currentDiagnostics, selectedDiagnostic];

    if (Array.isArray(diagnosticField)) {
      const [containerFieldKey, index, childField] = diagnosticField;
      const diagnosticContainerList = form.getFieldValue(containerFieldKey) || [];

      const updatedDiagnosticContainerList = [...diagnosticContainerList];
      updatedDiagnosticContainerList[index] = {
        ...updatedDiagnosticContainerList[index],
        [childField]: updatedDiagnostics,
      };

      form.setFieldsValue({
        [containerFieldKey]: updatedDiagnosticContainerList,
      });
    } else {
      form.setFieldsValue({
        [diagnosticField]: updatedDiagnostics,
      });
    }
  };

  return (
    <Row>
      <Col lg={24}>
        <Spin className="cmt-spin" spinning={diagnostic.loading}>
          <Select
            placeholder={placeholder}
            size="large"
            value={selected}
            style={{ width: '100%' }}
            showArrow
            allowClear
            showSearch
            filterOption={false}
            onChange={handleOnChange}
            onSearch={fetchDiagnostics}
          >
            {diagnostic?.data?.map((option) => {
              return (
                <Select.Option key={option.id} value={option.id} diagnostic={option}>
                  {option.code} - {option.description}
                </Select.Option>
              );
            })}
          </Select>
        </Spin>
      </Col>
    </Row>
  );
};

export default DiagnosticSelector;
